export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.fbe2662b.worker.js");
}
